import { useApi } from './useApi'

export function useNominatim() {
  const api = useApi()

  async function reverseGeocode(latlng) {
    return api.get(`/api/geocode/reverse?lat=${latlng.lat}&lon=${latlng.lng}`)
  }

  // Opcionales: `near` ({ lat, lng }) prioriza resultados cercanos a esa zona
  // y `country` (código ISO de 2 letras, ej. 'ar') limita la búsqueda a ese país.
  async function geocodeAddress(address, near, country) {
    const bias = near ? `&lat=${near.lat}&lng=${near.lng}` : ''
    const pais = country ? `&country=${country}` : ''
    return api.get(`/api/geocode/search?q=${encodeURIComponent(address)}${bias}${pais}`)
  }

  return { reverseGeocode, geocodeAddress }
}
